import React from 'react';
import Button from '@material-ui/core/Button';

const SecondaryButton = (props) => {
  return (
    <Button variant="outlined" {...props}>
      {props.children}
    </Button>
  );
};

export { SecondaryButton };
